import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withRadium, DetectCompact } from 'higher-order-components'
import { Bubble, RadioIcon } from 'components'

/** Radio Group Component. */
// @todo remove this component
class InteriorSelector extends Component {
  constructor(props) {
    super(props)
    this.state = {
      hover: -1,
      active: props.active || 0,
      uniqueID: Math.random()
    }
  }
  static propTypes = {
    onChange: PropTypes.func,
    active: PropTypes.number,
    options: PropTypes.array,
    scrollEnable: PropTypes.bool,
    divider: PropTypes.bool,
    primary: PropTypes.bool,
    only: PropTypes.bool,
    type: PropTypes.string,
    padding: PropTypes.string,
    showActiveLabel: PropTypes.bool,
    extraLabelCustomStyle: PropTypes.object,
    labelCustomStyle: PropTypes.object,
    dataTest: PropTypes.string
  }

  static defaultProps = {
    showActiveLabel: false,
    type: 'radio'
  }

  handleChange = (index, option) => {
    this.setState({
      active: index
    }, () => {
      this.props.onChange && this.props.onChange(option, index)
    })
  }
  handleMouseOver = (index) => {
    this.setState({ hover: index })
  }
  handleMouseOut = () => {
    this.setState({ hover: -1 })
  }

  render() {
    let flow = true
    let inline = false
    const active = this.state.active
    this.props.options.forEach((option) => {
      if (option.hex || option.icon) flow = false
      if (option.hex || option.icon) inline = true
    })
    return (
      <div style={{ position: 'relative' }} data-test={this.props.dataTest}>
        <div
          style={[
            styles.base,
            this.props.compact && {
              overflowX: 'auto',
              overflowY: 'hidden'
            },
            { padding: this.props.padding || '0px' }
          ]}
          data-test="radio-group">
          <div
            ref={(c) => {
              this.radioGroup = c
            }}
            style={[
              this.props.scrollEnable && styles.wrapper,
              styles.padding
            ]}>
            {this.props.options.map((option, index) => {
              const divider = this.props.divider && index < this.props.options.length - 1
              return (
                <div style={styles.option} ref={index} key={index}>
                  <label
                    htmlFor={`interior-selector-input-${index}-${this.state.uniqueID}`}
                    data-test="radio-group-label"
                    data-value={option.slug}
                    style={[
                      styles.label,
                      !this.props.only && styles.enabled,
                      styles.inline,
                      { ...this.props.labelCustomStyle }
                    ]}
                    ref={index}
                    onMouseOver={() => this.handleMouseOver(index)}
                    onMouseOut={this.handleMouseOut}>
                    {option.icon && (
                      <RadioIcon
                        icon={option.icon}
                        active={index === active}
                        hover={index === this.state.hover} />
                    )}
                    <input
                      key={`interior-selector-input-${index}-${this.state.uniqueID}`}
                      id={`interior-selector-input-${index}-${this.state.uniqueID}`}
                      style={styles.input}
                      type={'radio'}
                      name={this.props.type}
                      defaultValue={option.slug}
                      onChange={() => this.handleChange(index, option)}
                      checked={index === active} />
                    {inline && (
                      <Bubble
                        content={option.label || option.name}
                        bottom={-1}
                        show={index === this.state.hover} />
                    )}
                  </label>
                  {divider && <div style={styles.divider} />}
                  {index === active &&
                    option.extraLabel && (
                      <div style={[styles.extraLabel, this.props.extraLabelCustomStyle]}>
                        {option.extraLabel}
                      </div>
                    )}
                </div>
              )
            })}
          </div>
        </div>
        {this.props.showActiveLabel && (
          <div
            style={{
              color: '#999',
              fontWeight: 200,
              fontSize: '100%',
              textAlign: 'center',
              paddingBottom: '1.5em'
            }}>
            {this.props.options[this.state.active].name}
          </div>
        )}
      </div>
    )
  }
}

export default withRadium(DetectCompact())(InteriorSelector)

const styles = {
  base: {
    position: 'relative',
    boxSizing: 'border-box',
    display: 'flex',
    justifyContent: 'center'
  },
  divider: {
    display: 'inline-block',
    width: '2px',
    height: '.8em',
    margin: '0 1em',
    verticalAlign: 'middle',
    background: '#d5d5d5'
  },
  wrapper: {
    whiteSpace: 'nowrap',
    position: 'relative',
    WebkitOverflowScrolling: 'touch'
  },
  padding: {
    fontSize: 0,
    display: 'inline-flex'
  },
  option: {
    position: 'relative',
    display: 'inline-block'
  },
  input: {
    opacity: '0',
    position: 'absolute',
    ':focus': {}
  },
  label: {
    fontSize: '16px',
    position: 'relative',
    display: 'inline-block',
    padding: '1em .5em',
    userSelect: 'none'
  },
  extraLabel: {
    position: 'absolute',
    bottom: '-2em',
    height: '2em',
    left: '50%',
    textAlign: 'center',
    lineHeight: 2.1,
    padding: '1em 0',
    boxSizing: 'border-box',
    transform: 'translateX(-50%)',
    whiteSpace: 'nowrap'
  },
  enabled: {
    cursor: 'pointer'
  },
  inline: {
    display: 'inline-block',
    whiteSpace: 'nowrap'
  },
  fadeRight: {
    position: 'absolute',
    top: 0,
    right: 0,
    width: '5em',
    height: '100%',
    background: 'linear-gradient(to left, #f5f5f5, rgba(245, 245, 245, 0))',
    pointerEvents: 'none',
    zIndex: 5
  }
}



// WEBPACK FOOTER //
// ./src/components/interior-selector/index.js